module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\"><defs><style></style></defs><title>gray circle arrow</title><g id=\"Page-1\"><g id=\"Landing\"><g id=\"Hero-Slides\"><g id=\"gray-circle-arrow\"><path id=\"Combined-Shape\" d=\"M0,22.5A22.5,22.5,0,1,1,22.5,45,22.5,22.5,0,0,1,0,22.5Zm5.39-5.66,17.49,22,17.49-22h-7.9l-6.16,7.69L22.88,29l-3.43-4.48-6.16-7.69Z\"></path></g></g></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home-arrow.svg
// module id = 505
// module chunks = 1